module.exports = __webpack_public_path__ + "static/media/03.e902695e.jpeg";